// extracted by mini-css-extract-plugin
export default {"pastelGray":"#eaecf0","scrollArea":"styles_scrollArea__FkUnL"};